import React from 'react';
import styled from 'styled-components';
import useContentAsociacionUsuarios from '../hooks/parameter/useContentAsociacionUsuarios';
import { SectionButtonsAsociaonUsuarios } from './Layout/SectionButtonsAsociaonUsuarios';

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;

  p {
    text-align: center;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;

export const PageAsociacionUsuarios = () => {
  window.scroll(0, 0);
  const { asociacionUsuarios } = useContentAsociacionUsuarios();
  const bodyHTML =
    asociacionUsuarios.length > 0 && asociacionUsuarios[0].texto_completo;

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <DivContainer id='contBodyHTML'>
          <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
          <SectionButtonsAsociaonUsuarios />
        </DivContainer>
      </div>
    </>
  );
};
